import { render } from "./KeytsTable.vue?vue&type=template&id=3b8cde86&scoped=true"
import script from "./KeytsTable.vue?vue&type=script&lang=js"
export * from "./KeytsTable.vue?vue&type=script&lang=js"

import "./KeytsTable.vue?vue&type=style&index=0&id=3b8cde86&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8cde86"]])

export default __exports__